<template>
  <div class="container">
    <div :class="['header', 'flx-justify-between', { scrolled: isScrolled }]">
      <div class="logo">
        <img :src="isScrolled ? scrolledTopLogo : topLogo" alt />
      </div>
      <div class="nav-bar">
        <router-link to="/">巡舍机器人</router-link>
        <router-link to="/platform">数字平台</router-link>
        <router-link to="/news">媒体报道</router-link>
        <router-link to="/about">关于我们</router-link>
        <router-link to="/goin">联系我们</router-link>
      </div>
      <div class="language" style="visibility: hidden">
        <span>EN</span>
      </div>
    </div>
    <el-main ref="mainContainer">
      <div ref="sentinel" class="sentinel"></div>
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          @scrollToTop="handleScrollToTop"
        />
      </keep-alive>
      <router-view
        v-if="!$route.meta.keepAlive"
        @scrollToTop="handleScrollToTop"
      />
    </el-main>
  </div>
</template>
<script>
export default {
  name: "Layout",
  data() {
    return {
      isScrolled: false,
      observer: null,
      topLogo: require("@/assets/images/toplogo.png"),
      scrolledTopLogo: require("@/assets/images/toplogo2.png"),
    };
  },
  methods: {
    handleSelect() {},
    handleScroll(event) {
      const container = event.target; // 获取滚动容器
      const scrollPosition = container.scrollTop;
      const threshold = window.innerHeight;

      // console.log(scrollPosition, threshold);
      this.isScrolled = scrollPosition >= threshold;
    },
    handleScrollToTop() {
      // 在这里实现滚动到顶部的逻辑
      const mainElement = document.querySelector(".el-main");
      if (mainElement) {
        mainElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      const mainEl = this.$refs.mainContainer.$el;
      const sentinel = this.$refs.sentinel;
      // 创建 IntersectionObserver
      this.observer = new IntersectionObserver(
        ([entry]) => {
          // console.log(entry);

          // entry.isIntersecting 为 true 表示 sentinel 在视口内
          // 也就意味着 “还没滚到阈值”
          this.isScrolled = !entry.isIntersecting;
        },
        {
          root: mainEl, // 被观察的滚动容器
          rootMargin: `0px 0px -${window.innerHeight}px 0px`,
          threshold: 0, // 一有交叉就触发
        }
      );
      // 开始观察 sentinel
      if (sentinel) {
        this.observer.observe(sentinel);
      }
    });
  },
  beforeUnmount() {
    if (this.observer && this.$refs.sentinel) {
      this.observer.unobserve(this.$refs.sentinel);
      this.observer.disconnect();
    }
  },
};
</script>
<style lang="scss" scoped>
.sentinel {
  height: 0px;
}
.container {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  .header {
    box-sizing: border-box;
    width: 100%;
    height: 8vh;
    padding: 0 6.0547vw;
    // background-color: rgb(229, 182, 182);
    background-color: transparent;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 999;

    .logo {
      width: 8.7031vw;
      padding: 5px;
      height: 6vh;
      box-sizing: border-box;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    &.scrolled {
      background-color: #ffffff;
      border-bottom: 1px solid #f8f7f7;
      box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
      .nav-bar a {
        color: #333;
      }
      .language {
        color: #333;
        border: 1px solid #333;
      }
    }
  }
  .nav-bar {
    margin-left: 5vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 8vh;
    // background-color: rgb(229, 182, 182);
    // background-color: transparent;
  }

  .nav-bar a {
    text-decoration: none;
    color: #fff;
    padding: 0 2.8rem;
    font-size: 1.8vh;
  }

  .nav-bar a.router-link-exact-active {
    font-weight: bold;
    // color: #42b983; /* 当前激活链接的高亮颜色 */
  }
  .language {
    cursor: pointer;
    width: 1.7234vw;
    height: 1.7234vw;
    border-radius: 50%;
    border: 1px solid #ffffff;
    text-align: center;
    line-height: 1.7234vw;
    color: #fff;
  }

  .el-main {
    padding: 0;
    height: 100vh;
  }
}
</style>